import React from "react";

const TopicCard = ({topic, selectedItems, handleItemSelected}) => {
    const {id, media_url, name} = topic;
    const isSelected = selectedItems?.find(v => v.id === id);

    return (
        <div
            key={id}
            className={`speaker_card gutter-b mx-2 p-3 rounded card shadow ${isSelected ? "selected" : ""}`}
            onClick={() => {
                if (isSelected) {
                    const removeSelected = selectedItems.filter(v => v.id !== id);
                    if (removeSelected.length) handleItemSelected(removeSelected);
                } else {
                    handleItemSelected([...selectedItems, topic]);
                }
            }}
        >
            <div className="d-flex flex-column w-100 h-100 justify-content-between align-items-center">
                <div
                    className="w-60px h-60px mx-auto my-4 rounded-circle border border-gray shadow bg_image_cover"
                    style={{
                        backgroundImage: `url(${media_url || "/media/dummy/dummy-img.jpg"})`,
                    }}
                />
                <p className="font-weight-bold elipsis_2lines text-dark">{name}</p>
            </div>
        </div>
    );
};

export default TopicCard;
